/** @jsx jsx */
import { jsx } from '@emotion/core';
import style from './style';

var _ref =
/*#__PURE__*/
jsx("div", null);

var _ref2 =
/*#__PURE__*/
jsx("div", null);

var _ref3 =
/*#__PURE__*/
jsx("div", null);

var _ref4 =
/*#__PURE__*/
jsx("div", null);

var _ref5 =
/*#__PURE__*/
jsx("div", null);

export default function Pacman(_ref6) {
  var color = _ref6.color,
      loading = _ref6.loading;

  if (loading) {
    return jsx("div", {
      css: style(color)
    }, _ref, _ref2, _ref3, _ref4, _ref5);
  }

  return null;
}